import { render, staticRenderFns } from "./GlossesByInsurance.vue?vue&type=template&id=85434cc6"
import script from "./GlossesByInsurance.vue?vue&type=script&lang=js"
export * from "./GlossesByInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports